import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTestinComponent } from './simple-icons-testin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTestinComponent ],
    exports:      [ SimpleIconsTestinComponent ],
    bootstrap:    []
})
export class SimpleIconsTestinModule {}
